<template>
	<transition :name="transitionName">
		<aside
			v-show="isActive"
			class="ks-navigation-drawer"
			:class="classes"
			:style="styles"
			ref="drawer"
		>
			<div class="ks-navigation-drawer-content">
				<slot></slot>
			</div>
		</aside>
	</transition>
</template>

<script>
export default {
	name: "KNavigationDrawer",
	props: {
		value: {
			type: Boolean,
			default: true
		},
		right: {
			type: Boolean,
			default: false
		},
		fixed: {
			type: Boolean,
			default: false
		},
		absolute: {
			type: Boolean,
			default: false
		},
		app: {
			type: Boolean,
			default: false
		},
		clipped: {
			type: Boolean,
			default: false
		},
		temporary: {
			type: Boolean,
			default: false
		},
		permanent: {
			type: Boolean,
			default: false
		},
		stateless: {
			type: Boolean,
			default: false
		},
		width: {
			type: [Number, String],
			default: 300
		},
		miniVariantWidth: {
			type: [Number, String],
			default: 80
		},
		miniVariant: {
			type: Boolean,
			default: false
		},
		disableResizeWatcher: {
			type: Boolean,
			default: false
		},
		disableRouteWatcher: {
			type: Boolean,
			default: false
		},
		hideOverlay: {
			type: Boolean,
			default: false
		},
		floating: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			isActive: this.value,
			isMini: this.miniVariant,
			overlayEl: null
		}
	},
	computed: {
		computedWidth () {
			if (this.isMini) return this.toPx(this.miniVariantWidth)
			return this.toPx(this.width)
		},
		classes () {
			return {
				"ks-navigation-drawer-fixed": this.fixed || this.app,
				"ks-navigation-drawer-absolute": this.absolute,
				"ks-navigation-drawer-right": this.right,
				"ks-navigation-drawer-mini": this.isMini,
				"ks-navigation-drawer-temporary": this.temporary,
				"ks-navigation-drawer-floating": this.floating,
				"ks-navigation-drawer-clipped": this.clipped,
				"ks-navigation-drawer-open": this.isActive
			}
		},
		styles () {
			return {
				width: this.computedWidth,
				transform: this.isActive ? "translateX(0)" : (this.right ? "translateX(100%)" : "translateX(-100%)")
			}
		},
		transitionName () {
			return this.right ? "ks-drawer-right" : "ks-drawer-left"
		}
	},
	watch: {
		value (val) {
			this.isActive = val
		},
		isActive (val) {
			this.$emit("input", val)
			this.updateOverlay()
		},
		miniVariant (val) {
			this.isMini = val
		},
		isMini (val) {
			this.$emit("update:mini-variant", val)
			this.$emit("update:miniVariant", val)
		},
		"$route" (newValue) {
			console.log(newValue.meta);
			if (newValue.meta.showNavigationDrawer === true) {
				this.isActive = true;
				return;
			}

			if (!this.disableRouteWatcher && this.temporary) {
				this.isActive = false
			}
			// Tarkistus vielä että jos eka osa routesta muuttuu niin ei tehdä tätä, vai pitäskö olla routen metadatassa...
			else if (!this.disableRouteWatcher  && window.innerWidth < 960) {
				console.log("JOO");
				this.isActive = false
			}
		}
	},
	mounted () {
		if (!this.disableResizeWatcher) {
			window.addEventListener("resize", this.onResize)
		}
		this.updateOverlay()
	},
	beforeDestroy () {
		window.removeEventListener("resize", this.onResize)
		this.removeOverlay()
	},
	methods: {
		toPx (val) {
			if (typeof val === "number") return val + "px"
			if (String(val).match(/^\d+$/)) return val + "px"
			return val
		},
		onResize () {
			if (this.permanent || this.stateless) return
/*			if (!this.temporary && window.innerWidth < 1264) {
				this.isActive = false
			} else if (!this.temporary && window.innerWidth >= 1264) {
				this.isActive = true
			}*/
		},
		updateOverlay () {
			if (this.temporary && this.isActive && !this.hideOverlay) {
				this.showOverlay()
			} else {
				this.removeOverlay()
			}
		},
		showOverlay () {
			if (this.overlayEl) return
			this.overlayEl = document.createElement("div")
			this.overlayEl.className = "ks-navigation-drawer-overlay"
			this.overlayEl.addEventListener("click", this.closeDrawer)
			// Sibling of the drawer so both share a stacking context (overlay 199 < drawer 200)
			this.$el.parentNode.insertBefore(this.overlayEl, this.$el)
			// Force reflow
			void this.overlayEl.offsetWidth
			this.overlayEl.classList.add("ks-navigation-drawer-overlay-active")
		},
		removeOverlay () {
			if (!this.overlayEl) return
			this.overlayEl.removeEventListener("click", this.closeDrawer)
			this.overlayEl.remove()
			this.overlayEl = null
		},
		closeDrawer () {
			this.isActive = false
		}
	}
}
</script>

<style>
.ks-navigation-drawer {
	position: relative;
	display: flex;
	flex-direction: column;
	top: 0;
	bottom: 0;
	height: 100%;
	max-height: 100%;
	overflow-x: hidden;
	overflow-y: auto;
	transition: transform 0.2s ease, width 0.2s ease;
	z-index: var(--ks-z-drawer, 4);
	will-change: transform;
}

@media (max-width: 960px) {
	.ks-navigation-drawer {
		width: 90% !important;
	}
}

.ks-navigation-drawer-fixed {
	position: fixed;
	top: 0;
	bottom: 0;
}

.ks-navigation-drawer-absolute {
	position: absolute;
	top: 0;
	bottom: 0;
}

.ks-navigation-drawer-right {
	right: 0;
	left: auto;
}

.ks-navigation-drawer:not(.ks-navigation-drawer-right) {
	left: 0;
	right: auto;
}

.ks-navigation-drawer-mini {
	overflow: hidden;
}

.ks-navigation-drawer-mini .ks-navigation-drawer-content {
	overflow: hidden;
}

.ks-navigation-drawer-temporary {
	z-index: var(--ks-z-drawer-temporary, 6);
}

.ks-navigation-drawer-floating {
	border: none !important;
	box-shadow: none !important;
}

.ks-navigation-drawer-clipped {
	top: 64px;
	max-height: calc(100% - 64px);
}

.ks-navigation-drawer-content {
	flex: 1 1 auto;
	overflow-y: auto;
	overflow-x: hidden;
}

.ks-navigation-drawer-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	opacity: 0;
	z-index: var(--ks-z-drawer-overlay, 5);
	transition: opacity 0.2s ease;
}

.ks-navigation-drawer-overlay-active {
	opacity: 1;
}
</style>
